module.exports = __webpack_public_path__ + "static/media/Bread.b8a53893.png";